﻿ import { defineStore } from "pinia";
import { useLocationStore } from "./location.js";
import { useKeycloakStore } from "./keycloak.js";

const path = import.meta.env.VITE_APP_URL + "payment";

export const usePaymentStore = defineStore("payment", {
  state: () => ({
    QRCode: "",
    QRCodeToClaim: "",
    QRCodeToCashOut: "",
    decodedQRCode: "",
    paymentTransaction: "",
    paymentTransactionList: "",
    paymentError: "",
    cardInfo: "",
    staticQRCode: "",
    vendorQRCodeList: "",
    qrCodeUser: "",
    qrTransaction: "",
    allQrTransactions: "",
    qrUser: "",
    qrCodeData: "",
  }),
persist: true,
  getters: {},

  actions: {
    getCardInfo(cardInfo) {
      this.cardInfo = cardInfo;
    },

    setDecodedQRCode(payload) {
      this.decodedQRCode = payload;
    },

    async makePayment(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/make`,
        method: "POST",
        data: payload,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((paymentTransaction) => {
          this.paymentTransaction = paymentTransaction;
          console.log(paymentTransaction);
          console.log(payload);
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
          this.paymentError = err.response.data;
        });
    },

    async validatePayment(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/validatePayment`,
        method: "POST",
        params: {
          userId: useKeycloakStore().subject,
          transferCode: payload.transferCode,
          transferPIN: payload.transferPIN,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((paymentTransaction) => {
          console.log(paymentTransaction);
          this.paymentTransaction = paymentTransaction;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async cancelPayment(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/cancel`,
        method: "PUT",
        params: {
          transferCode: payload.transferCode,
          transferPIN: payload.transferPIN,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((paymentTransaction) => {
          console.log(paymentTransaction);
          this.paymentTransaction = paymentTransaction;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getPayeePaymentTransactions(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/get/payee/paymentTransactions`,
        method: "GET",
        params: {
          payeeUserId: payload,
          userId: useKeycloakStore().subject,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((paymentTransactionList) => {
          this.paymentTransactionList = paymentTransactionList;
          console.log(paymentTransactionList);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },

    async getPayerPaymentTransactions(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/get/payer/paymentTransactions`,
        method: "GET",
        params: {
          payerUserId: payload,
          userId: useKeycloakStore().subject,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((paymentTransactionList) => {
          this.paymentTransactionList = paymentTransactionList;
          console.log(paymentTransactionList);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },

    async createQRcode(payload) {
      const axios = (await import("axios")).default;

      console.log(payload);
      axios({
        url: `${path}/createQrCode`,
        data: payload,
        method: "POST",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((res) => res.data)
        .then((qrCodeData) => {
          console.log(qrCodeData);
          this.qrCodeData = qrCodeData;

          if (payload.type === "avo\xA2ash pay") {
            this.QRCode =
              "data:image/png;base64," + qrCodeData.qrCode;
          } else if (payload.type === "avo\xA2ash claim") {
            this.QRCodeToClaim =
              "data:image/png;base64," + qrCodeData.qrCode;
          } else if (
            payload.type === "avo\xA2ash out" ||
            "avo\xA2ash ATM"
          ) {
            this.QRCodeToCashOut =
              "data:image/png;base64," + qrCodeData.qrCode;
          }
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async decodeQRCode(payload) {
      const axios = (await import("axios")).default;
      const locationStore = useLocationStore();
      axios({
        url: `${path}/decodeQRCode`,
        method: "GET",
        params: {
          qrCodeText: payload,
          geolocation:
            locationStore.latitude +
            "-" +
            locationStore.longitude,
          ipAddress: locationStore.ipAddress,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((decodedQRCode) => {
          console.log(decodedQRCode);
          this.decodedQRCode = decodedQRCode;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async decodeVendorQRCode(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/decode_vendor_QrCode`,
        method: "GET",
        params: {
          qrCodeText: payload,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((decodedQRCode) => {
          console.log(decodedQRCode);
          this.decodedQRCode = decodedQRCode;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async deleteQRCode(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/deleteQRCode`,
        params: {
          paymentDataId: payload,
        },
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((qrCodeData) => {
          this.qrCodeData = "";
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async createVendorQRCode(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/create_vendor_QrCode`,
        data: payload,
        method: "POST",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((staticQRCode) => {
          this.staticQRCode = staticQRCode;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async getStaticQrCode(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/get/qrCode`,
        params: {
          staticQRCodeId: payload.id,
        },
        method: "GET",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((staticQRCode) => {
          console.log("staticQRCode", staticQRCode);
          this.staticQRCode = staticQRCode;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async addQRCodeAmount(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/add/QrCode_amount`,
        data: payload,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((vendorQRCodeList) => {
          this.vendorQRCodeList = vendorQRCodeList;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async editAmountDescription(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/edit/QrCode_amount`,
        params: { staticQrCodeId: payload },
        method: "PUT",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((vendorQRCodeList) => {
          this.vendorQRCodeList = vendorQRCodeList;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async cancelQRAmount(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/cancel/QrCode_amount`,
        params: { staticQrCodeId: payload },
        method: "PUT",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((vendorQRCodeList) => {
          this.vendorQRCodeList = vendorQRCodeList;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async getVendorQRCodeList() {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/userQrCodeList`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((vendorQRCodeList) => {
          console.log("vendorQRCodeList", vendorQRCodeList);
          this.vendorQRCodeList = vendorQRCodeList;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async getQrTransctionList(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/staticQrCode/transactions`,
        params: {
          staticQrCodId: payload.id,
          maxNumberOfItem: payload.maxNumberOfItem,
        },
        method: "GET",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((allQrTransactions) => {
          this.allQrTransactions = allQrTransactions;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async addQrCodeUser(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/add/QrCodeUser`,
        params: {
          staticQRCodeId: payload.id,
          qrCodeUserId: payload.userId,
        },
        method: "POST",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((staticQRCode) => {
          console.log("staticQRCode", staticQRCode);
          this.staticQRCode = staticQRCode;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },

    async removeQrCodeUser(payload) {
      const axios = (await import("axios")).default;

      axios({
        url: `${path}/remove/QrCodeUser`,
        params: {
          staticQRCodeId: payload.id,
          qrCodeUserId: payload.userId,
        },
        method: "PUT",
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((staticQRCode) => {
          this.staticQRCode = staticQRCode;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
        });
    },
  },
});
